import React, { useState } from 'react';
import AppDropdown from '../../../../components/AppDropdown';
import { appToast } from '../../../../components/AppToast';

export default function SalaryPaymentModal({ isOpen, onClose, month = 'Jul', year = '2026' }) {
  const [bankAccount, setBankAccount] = useState('HDFC Bank - 00492819003');
  const [paymentMode, setPaymentMode] = useState('Bank Transfer (NEFT/RTGS)');
  const [referenceNumber, setReferenceNumber] = useState(`PAY-SAL-${month.toUpperCase()}-${year}-01`);
  const [isProcessing, setIsProcessing] = useState(false);

  if (!isOpen) return null;

  const bankOptions = [
    { value: 'HDFC Bank - 00492819003', label: 'HDFC Bank - 00492819003 (Main Salary A/c)' },
    { value: 'ICICI Bank - 88192004122', label: 'ICICI Bank - 88192004122 (Operations)' },
    { value: 'State Bank of India - 4401928310', label: 'State Bank of India - 4401928310' },
    { value: 'Cash in Hand', label: 'Cash in Hand (Petty Cash)' },
  ];

  const paymentModeOptions = [
    { value: 'Bank Transfer (NEFT/RTGS)', label: 'Bank Transfer (NEFT/RTGS / Direct Payout)' },
    { value: 'Cheque', label: 'Corporate Cheque' },
    { value: 'Cash', label: 'Direct Cash Disbursal' },
    { value: 'UPI / IMPS', label: 'Instant Settlement (UPI / IMPS)' },
  ];

  const handleDisburse = () => {
    setIsProcessing(true);
    setTimeout(() => {
      setIsProcessing(false);
      appToast.success(`Salary payment disbursed via ${paymentMode} successfully! Reference: ${referenceNumber}`);
      onClose();
    }, 1100);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-xs p-4 animate-in fade-in duration-150">
      <div className="w-full max-w-lg rounded-2xl border border-outline-variant/30 bg-surface-container-lowest p-6 shadow-2xl space-y-6">
        
        {/* Header */}
        <div className="flex items-center justify-between border-b border-outline-variant/20 pb-4">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
              <span className="material-symbols-outlined text-2xl">payments</span>
            </div>
            <div>
              <h3 className="text-base font-bold text-on-surface">
                Disburse Salary Payment
              </h3>
              <p className="text-xs text-on-surface-variant font-medium">
                Execute salary disbursements for {month} {year}.
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="h-8 w-8 rounded-lg text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface flex items-center justify-center transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-lg">close</span>
          </button>
        </div>

        {/* Form Body */}
        <div className="space-y-4 text-xs">
          <label className="grid gap-1.5 font-bold text-on-surface-variant">
            <span>Disbursement Bank Account</span>
            <AppDropdown
              options={bankOptions}
              value={bankAccount}
              onChange={setBankAccount}
              triggerClassName="h-9 w-full rounded-xl border border-outline-variant/30 bg-surface-container-lowest px-3 text-xs"
            />
          </label>

          <label className="grid gap-1.5 font-bold text-on-surface-variant">
            <span>Payment Mode</span>
            <AppDropdown
              options={paymentModeOptions}
              value={paymentMode}
              onChange={setPaymentMode}
              triggerClassName="h-9 w-full rounded-xl border border-outline-variant/30 bg-surface-container-lowest px-3 text-xs"
            />
          </label>

          <label className="grid gap-1.5 font-bold text-on-surface-variant">
            <span>Payment Reference / Batch No.</span>
            <input
              type="text"
              value={referenceNumber}
              onChange={(e) => setReferenceNumber(e.target.value)}
              className="h-9 rounded-xl border border-outline-variant/30 bg-surface-container-lowest px-3 text-xs text-on-surface outline-none focus:ring-2 focus:ring-primary/20"
            />
          </label>

          {/* Amount summary box */}
          <div className="rounded-xl border border-outline-variant/20 bg-surface-container-low p-4 flex items-center justify-between">
            <div>
              <span className="text-[11px] font-bold text-on-surface-variant uppercase tracking-wider">Total Net Payable</span>
              <p className="text-xl font-black text-primary font-display">₹ 4,69,500.00</p>
            </div>
            <div className="text-right">
              <span className="text-[11px] font-bold text-on-surface-variant uppercase tracking-wider">Recipients</span>
              <p className="text-sm font-bold text-on-surface">7 Active Employees</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 border-t border-outline-variant/20 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-5 py-2.5 rounded-xl bg-surface-container-high hover:bg-surface-container-highest text-on-surface text-xs font-bold transition cursor-pointer"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleDisburse}
            disabled={isProcessing}
            className="px-6 py-2.5 rounded-xl bg-primary hover:bg-primary/90 text-on-primary text-xs font-bold shadow-sm transition disabled:opacity-50 flex items-center gap-2 cursor-pointer"
          >
            {isProcessing ? (
              <>
                <span className="material-symbols-outlined text-sm animate-spin">progress_activity</span>
                <span>Disbursing...</span>
              </>
            ) : (
              <>
                <span className="material-symbols-outlined text-sm">send</span>
                <span>Execute Payment</span>
              </>
            )}
          </button>
        </div>

      </div>
    </div>
  );
}
